import React from 'react'
import EditCorporateMembersForm from '../../features/viewCorporateMember/EditCorporateMembersForm'

const EditCorporateMembers = () => {
    return (<EditCorporateMembersForm />)
}

export default EditCorporateMembers